window.ShowroomAppointmentForm = {
  getShopifyFormEmbed() {
    if (!this.formStep) return null;

    return this.formStep.querySelector("shopify-forms-embed");
  },

  getShopifyFormRoot() {
    const formEmbed = this.getShopifyFormEmbed();

    return formEmbed?.shadowRoot || this.formStep || null;
  },

  findField(fieldName) {
    const root = this.getShopifyFormRoot();

    if (!root) return null;

    return (
      root.querySelector(`[id="custom#${fieldName}"]`) ||
      root.querySelector(`[data-testid="field-custom#${fieldName}"]`) ||
      root.querySelector(`[name="custom#${fieldName}"]`) ||
      root.querySelector(`[name*="${fieldName}"]`) ||
      root.querySelector(`[placeholder="${fieldName}"]`) ||
      root.querySelector(`[aria-label="${fieldName}"]`)
    );
  },

  hideTechnicalFields() {
    const root = this.getShopifyFormRoot();

    if (!root) return;

    const fieldIds = [
      "custom#slot_metaobject_id",
      "custom#selected_date",
      "custom#selected_time",
      "custom#selected_timezone",
    ];

    fieldIds.forEach((id) => {
      const field = root.querySelector(`[id="${id}"]`);

      if (!field) return;

      const container =
        field.closest('[class*="_formFieldContainer_"]') ||
        field.closest('[class*="formFieldContainer"]') ||
        field.closest(".form-field") ||
        field.parentElement;

      if (container) {
        container.style.display = "none";
      }
    });
  },

  waitForShopifyFormFields() {
    let attempts = 0;
    const maxAttempts = 40;

    const interval = window.setInterval(() => {
      this.hideTechnicalFields();

      const slotMetaobjectIdField = this.findField("slot_metaobject_id");
      const selectedDateField = this.findField("selected_date");
      const selectedTimeField = this.findField("selected_time");
      const selectedTimezoneField = this.findField("selected_timezone");

      attempts += 1;

      const fieldsReady =
        slotMetaobjectIdField &&
        selectedDateField &&
        selectedTimeField &&
        selectedTimezoneField;

      if (fieldsReady || attempts >= maxAttempts) {
        this.watchShopifyFormSuccess?.();
        window.clearInterval(interval);
      }
    }, 250);
  },

  setFormValue(fieldName, value) {
    const field = this.findField(fieldName);

    if (!field) return;

    field.value = value ?? "";

    field.dispatchEvent(
      new Event("input", {
        bubbles: true,
        composed: true,
      }),
    );

    field.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true,
      }),
    );
  },

  watchShopifyFormSuccess() {
    const formEmbed = this.getShopifyFormEmbed();
    const root = formEmbed?.shadowRoot;

    if (!root || this.formSuccessObserver) return;

    this.formSuccessObserver = new MutationObserver(() => {
      const content = root.textContent?.toLowerCase() || "";

      const hasSuccess =
        content.includes("thank") ||
        content.includes("received") ||
        content.includes("submitted") ||
        content.includes("confirmed");

      if (!hasSuccess || this.formSuccessHandled) return;

      this.formSuccessHandled = true;
      this.handleAppointmentFormSuccess?.();
    });

    this.formSuccessObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  },
};
